export const handleErrorExpireMarginBoost = (
  error: any,
  onError: (message: string) => void,
): void => {
  const errorMessage =
    error.response?.data?.error ||
    'An error occurred while expiring the margin boost.';
  onError(errorMessage);
  console.error(errorMessage, error);
};
